// PÁROVANIE S MKSOFT ZÁKAZKOU — jeden komponent pre zákazku aj reklamáciu (0.J; Mirko 27. 9. 2026: mockup MKsoft párovanie OK)
// Online: pri otvorení si Matrix vyžiada zoznam ZAKAZKY od agenta na PO (3–13 s); keď agent neodpovie, ukáže posledný zoznam so značkou.
// Props: typ 'zakazka'|'reklamacia' · hodnota (aktuálny kód) · nazov, partnerId (na zhodu) · onVyber(kod|null, { rucne, mksoft })
//        · vlastnyId (id karty, aby jej vlastné číslo nebolo „obsadené“) · kompakt (jeden riadok do formulára)
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { Btn } from './Btn.jsx'
import { COLORS, TYPO, SPACE, RADIUS, hladaj } from '../theme.js'

const norm = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
const slova = (t) => norm(t).split(/[^a-z0-9]+/).filter(w => w.length > 2)
export const fmtDatum = (d) => { if (!d) return ''; const [y, m, dd] = String(d).slice(0, 10).split('-'); return dd && m ? Number(dd) + '. ' + Number(m) + '. ' + y : String(d) }

// Skóre zhody: slová názvu + rovnaký partner + čerstvosť založenia (len návrh — klikne človek)
export function skoreZhody(mk, { nazov, partnerId }) {
  let s = 0
  const a = slova(nazov), b = slova(mk.nazov)
  if (a.length && b.length) { const zh = a.filter(w => b.some(x => x.includes(w) || w.includes(x))).length; s += Math.round(60 * zh / Math.max(a.length, b.length)) }
  if (partnerId && mk.zakaznik && String(mk.zakaznik.id) === String(partnerId)) s += 30
  if (mk.datum_od) { const dni = (Date.now() - new Date(mk.datum_od).getTime()) / 86400000; if (dni >= 0 && dni < 14) s += 10; else if (dni < 60) s += 4 }
  return s
}

// ZAMESTNANEC_OSOBA_V1 (21. 10. 2026, nervová sústava Kronika 2525): + stavy „? návrh“ a „mimo MKsoftu“ — ten istý štítok pre zákazky, zamestnancov, partie aj Rozpis
export function StitokMKsoft({ kod, znamy = true, sparovane = true, title, navrh = false, mimo = false }) {
  const st = navrh ? ['? návrh', '#dbeafe', '#1d4ed8'] : mimo ? ['✗ mimo MKsoftu', '#f1f5f9', '#64748b'] : !kod ? ['✗ bez MKsoft čísla', '#fee2e2', '#b91c1c'] : !znamy ? ['! ' + kod + ' nie je v MKsofte', '#fef3c7', '#b45309'] : ['✓ MKsoft ' + kod, '#dcfce7', '#15803d']
  return <span title={title} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontWeight: 800, fontSize: 11, borderRadius: 999, padding: '1px 8px', fontFamily: TYPO.mono, background: st[1], color: st[2], whiteSpace: 'nowrap' }}>{st[0]}</span>
}

export default function ParovanieMKsoft({ typ = 'zakazka', hodnota = '', nazov = '', partnerId = '', vlastnyId = '', onVyber, kompakt = false, online = true, ajUkoncene = false, povolPrazdne = false, lenZoZoznamu = false }) {   // ZAKAZKA_CISLA_V1: povolPrazdne = číslo prázdnej karty z výdajok sa dá vybrať (zlúči sa), lenZoZoznamu = bez ručného čísla   // REK_REGISTER_V1C: ajUkoncene — ponúknuť aj ukončené MKsoft zákazky (staro-nová z reklamácie)
  const [data, setData] = useState(null)
  const [nacitava, setNacitava] = useState(false)
  const [q, setQ] = useState('')
  const [kurzor, setKurzor] = useState(0)
  const [rucne, setRucne] = useState(false)
  const [rucneKod, setRucneKod] = useState('')
  const inp = useRef(null)

  const nacitaj = async (onl) => {
    setNacitava(true)
    try { const r = await fetchAuth('/api/mksoft-zakazky' + (onl ? '?online=1' : '')); if (r.ok) setData(await r.json()) } catch (_) {} finally { setNacitava(false) }
  }
  useEffect(() => { nacitaj(online) }, [])   // eslint-disable-line

  const zoznam = useMemo(() => {
    if (!data) return []
    return data.zoznam
      .filter(z => ajUkoncene || !z.ukoncena || z.cislo === hodnota)   // REK_REGISTER_V1C
      .map(z => {
        const o = z.obsadene || z.sparovane
        const prazdna = !!(o && o.prazdna)   // ZAKAZKA_CISLA_V1: drží ho prázdna karta založená z výdajok
        const vlastne = !!o && String(o.id) === String(vlastnyId) && o.typ === typ
        const obsadene = !!o && (!vlastne || lenZoZoznamu) && !(povolPrazdne && prazdna)   // pri ďalšom čísle je aj vlastné číslo karty obsadené
        return { ...z, obsadene, prazdna, vlastne, skore: skoreZhody(z, { nazov, partnerId }) }
      })
      // bez hľadania len číselné kódy (RRNNNN), najnovšie hore; textové (STRAZSKE, ZUPCANY…) a staré roky sa nájdu hľadaním
      .filter(z => q ? hladaj(z.cislo + ' ' + z.nazov + ' ' + (z.zakaznik ? z.zakaznik.name : ''), q) : /^\d+$/.test(z.cislo))
      .sort((a, b) => (a.obsadene - b.obsadene) || (b.skore - a.skore) || (Number(b.cislo) || 0) - (Number(a.cislo) || 0) || b.cislo.localeCompare(a.cislo))
  }, [data, q, nazov, partnerId, vlastnyId, typ, hodnota, ajUkoncene, povolPrazdne, lenZoZoznamu])
  const volne = zoznam.filter(z => !z.obsadene)
  const vybrany = data && hodnota ? data.zoznam.find(z => z.cislo === hodnota) : null
  useEffect(() => { setKurzor(0) }, [q, data])

  const vyber = (z) => { if (!z || z.obsadene) return; onVyber && onVyber(z.cislo, { rucne: false, mksoft: z }) }
  const naKlaves = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setKurzor(k => Math.min(k + 1, volne.length - 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setKurzor(k => Math.max(k - 1, 0)) }
    else if (e.key === 'Enter') { e.preventDefault(); vyber(volne[kurzor]) }
    else if (e.key === 'Escape' && q) { e.preventDefault(); setQ('') }
  }
  const agent = data && data.agent
  const stavTxt = nacitava ? 'Načítavam z MKsoftu…' : !data ? '' : agent && agent.online ? 'MKsoft online (' + Math.round((agent.cas_ms || 0) / 1000) + ' s), ' + data.pocet + ' zákaziek' : 'Agent MKsoft neodpovedal — zoznam z ' + (data.nacitane_at ? fmtDatum(data.nacitane_at) : 'posledného načítania')
  const stavFarba = nacitava ? COLORS.muted : agent && agent.online ? '#15803d' : '#b45309'

  // Vybraté — jeden riadok so zmenou
  if (hodnota && !rucne) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <StitokMKsoft kod={hodnota} znamy={!data || data.pocet === 0 || !!vybrany} />
        {vybrany && <span style={{ fontSize: TYPO.sizes.sm }}>{vybrany.nazov}{vybrany.zakaznik ? ' · ' + vybrany.zakaznik.name : ''}</span>}
        {data && data.pocet > 0 && !vybrany && <span style={{ fontSize: TYPO.sizes.xs, color: '#b45309' }}>číslo v MKsofte nie je — overí sa pri ďalšom načítaní</span>}
        <Btn size="sm" onClick={() => onVyber && onVyber(null, { rucne: false, mksoft: null })}>Zmeniť</Btn>
      </div>
    )
  }

  const riadok = (z, i) => {
    const naj = i === 0 && !z.obsadene && z.skore >= 30 && !q
    return (
      <div key={z.cislo} onClick={() => vyber(z)} onMouseEnter={() => { if (!z.obsadene) setKurzor(volne.indexOf(z)) }}
        style={{ display: 'flex', alignItems: 'center', gap: 10, border: '1px solid ' + (z.obsadene ? COLORS.line : volne[kurzor] === z ? COLORS.nav || '#1d4ed8' : naj ? '#86efac' : COLORS.line), background: z.obsadene ? COLORS.bgSoft : naj ? '#f0fdf4' : '#fff', borderRadius: 10, padding: '6px 10px', marginBottom: 4, cursor: z.obsadene ? 'default' : 'pointer', opacity: z.obsadene ? .7 : 1 }}>
        <b style={{ fontFamily: TYPO.mono, minWidth: 62 }}>{z.cislo}</b>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ fontWeight: 600 }}>{z.nazov || '(bez názvu)'}</span>
          <small style={{ display: 'block', color: COLORS.muted }}>
            {z.datum_od ? 'MKsoft: ' + fmtDatum(z.datum_od) : ''}{z.zakaznik ? ' · ' + z.zakaznik.name : z.firmaid ? ' · firma ' + z.firmaid + ' (v Matrixe nie je)' : ''}
            {z.obsadene ? (z.vlastne ? ' · už je číslom tejto karty' : ' · ' + ((z.sparovane || {}).typ === 'reklamacia' ? 'patrí reklamácii ' : 'spárovaná so ') + ((z.sparovane || {}).nazov || '')) : z.prazdna ? ' · drží ho prázdna karta ' + ((z.sparovane || {}).id || '') + ' z výdajok — zlúči sa' : z.vlastne && (z.sparovane || {}).dalsie_cislo ? ' · ďalšie číslo tejto karty — stane sa hlavným, doterajšie hlavné bude ďalšie' : naj ? ' · zhoda ' + z.skore + ' %' : ''}
          </small>
        </span>
        {z.obsadene ? <span style={{ fontSize: 11, fontWeight: 800, color: '#b45309', background: '#fef3c7', borderRadius: 999, padding: '1px 8px' }}>obsadená</span>
          : naj ? <span style={{ fontSize: 11, fontWeight: 800, color: '#15803d', background: '#dcfce7', borderRadius: 999, padding: '1px 8px' }}>✓ vybrať</span>
          : <span style={{ fontSize: 11, color: COLORS.muted }}>vybrať</span>}
      </div>
    )
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
        <input ref={inp} value={q} onChange={e => setQ(e.target.value)} onKeyDown={naKlaves} placeholder="číslo alebo názov MKsoft zákazky…" autoFocus={!kompakt}
          style={{ flex: 1, minWidth: 180, padding: '7px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, fontSize: TYPO.sizes.md }} />
        <span style={{ fontSize: TYPO.sizes.xs, color: stavFarba, fontWeight: 700 }}>{stavTxt}</span>
        <Btn size="sm" onClick={() => nacitaj(true)} disabled={nacitava}>Načítať z MKsoftu znova</Btn>
      </div>
      <div style={{ maxHeight: kompakt ? 200 : 320, overflow: 'auto' }}>
        {zoznam.slice(0, 60).map((z, i) => riadok(z, i))}
        {data && !zoznam.length && <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, padding: 6 }}>{q ? 'Nič sa nenašlo.' : lenZoZoznamu ? 'Zoznam MKsoft zákaziek je prázdny — načítaj znova.' : 'Zoznam MKsoft zákaziek je prázdny — načítaj znova, alebo napíš číslo ručne.'}</div>}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
        {lenZoZoznamu ? <span>↑↓ pohyb · Enter vybrať · / hľadanie · ďalšie číslo sa vyberá len zo zoznamu MKsoftu</span> : !rucne ? <>
          <Btn size="sm" onClick={() => { setRucne(true); setRucneKod('') }}>Napísať číslo ručne</Btn>
          <Btn size="sm" onClick={() => onVyber && onVyber(null, { bezCisla: true, rucne: false, mksoft: null })}>{typ === 'reklamacia' ? 'Bez kódu' : 'V MKsofte ešte nie je — bez čísla'}</Btn>
          <span>↑↓ pohyb · Enter vybrať · / hľadanie</span>
        </> : <>
          <input value={rucneKod} onChange={e => setRucneKod(e.target.value.replace(/\D/g, '').slice(0, 8))} placeholder="napr. 260083" autoFocus
            onKeyDown={e => { if (e.key === 'Enter' && /^\d{4,8}$/.test(rucneKod)) { onVyber && onVyber(rucneKod, { rucne: true, mksoft: null }); setRucne(false) } if (e.key === 'Escape') setRucne(false) }}
            style={{ width: 120, padding: '5px 8px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, fontFamily: TYPO.mono }} />
          <Btn size="sm" variant="add" disabled={!/^\d{4,8}$/.test(rucneKod)} onClick={() => { onVyber && onVyber(rucneKod, { rucne: true, mksoft: null }); setRucne(false) }}>Použiť</Btn>
          <Btn size="sm" onClick={() => setRucne(false)}>Späť</Btn>
          <span>ručné číslo dostane žltý štítok, kým ho MKsoft nepotvrdí</span>
        </>}
      </div>
    </div>
  )
}

// Stav spárovania na karte zákazky (Info › MKsoft č.): štítok + Spárovať / Zmeniť / Odpojiť — zapisuje cez /api/mksoft-zakazky
import { Modal } from './Modal.jsx'
import { useToast } from './Toast.jsx'
import { useConfirm } from './ConfirmDialog.jsx'   // ZAKAZKA_CISLA_V1
import { SK } from '../theme.js'
export function MksoftParovanieOkno({ project, open, onClose, onChanged }) {
  const toast = useToast()
  const [pracuje, setPracuje] = useState(false)
  const kod = String(project.zakazka_code || project.mksoft_cislo || '').trim()
  const setOkno = (v) => { if (!v) onClose && onClose() }
  const sparuj = async (cislo, meta) => {
    if (meta && meta.bezCisla) { setOkno(false); return }
    if (!cislo) return
    setPracuje(true)
    try {
      const r = await fetchAuth('/api/mksoft-zakazky/' + encodeURIComponent(cislo) + '/sparovat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ project_id: project.id, rucne: !!(meta && meta.rucne) }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) { toast.error(j.error || 'Nepodarilo sa spárovať.'); return }
      toast.success('Spárované s MKsoft ' + cislo + (j.doklady_priradene ? ' — priradených dokladov: ' + j.doklady_priradene : '') + (j.doklady_odpojene ? ', odpojených: ' + j.doklady_odpojene : ''))
      setOkno(false); onChanged && onChanged()
    } catch (e) { toast.error(e.message) } finally { setPracuje(false) }
  }
  const odpoj = async () => {
    setPracuje(true)
    try {
      const r = await fetchAuth('/api/mksoft-zakazky/odpojit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ project_id: project.id }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) { toast.error(j.error || 'Nepodarilo sa odpojiť.'); return }
      toast.success('Odpojené — karta je bez MKsoft čísla' + (j.doklady_odpojene ? ', dokladov vrátených do Importov: ' + j.doklady_odpojene : ''))
      setOkno(false); onChanged && onChanged()
    } catch (e) { toast.error(e.message) } finally { setPracuje(false) }
  }
  return (
    <Modal open={!!open} onClose={() => !pracuje && setOkno(false)} title={kod ? 'Zmeniť spárovanie — ' + project.id + ' ' + (project.name || '') : 'Spárovať s MKsoft zákazkou — ' + project.id + ' ' + (project.name || '')} width="min(640px, 95vw)"
      subtitle={kod ? 'Teraz spárované: ' + kod + '. Doklady priradené podľa starého čísla sa vrátia do Importov, s novým číslom sa priradia sem. Ručne priradené doklady sa nemenia.' : 'Matrix načíta zoznam z MKsoftu a ponúkne zákazku, ktorá sedí.'}
      footer={<>{kod && <Btn variant="danger" onClick={odpoj} disabled={pracuje}>Odpojiť (bez čísla)</Btn>}<span style={{ flex: 1 }} /><Btn onClick={() => setOkno(false)} disabled={pracuje}>Zrušiť</Btn></>}>
      {open && <ParovanieMKsoft typ="zakazka" hodnota="" nazov={project.name} partnerId={project.customerId} vlastnyId={project.id} onVyber={sparuj} />}
    </Modal>
  )
}

// ZAKAZKA_CISLA_V1 (Mirko 27. 10. 2026, Kronika matrix 3712, mockup A2 „+ číslo“): ďalšie číslo tej istej stavby v MKsofte.
// Pred zápisom súhrn zo servera (12.0 b. 3): koľko výdajok a FA prejde, koľko FA do príjmu, či sa zlúči prázdna karta z výdajok (modules/zakazka_cisla.js).
export async function pridajDalsieCislo({ cislo, projectId, opytajSa, toast }) {
  const posli = async (telo) => { const r = await fetchAuth('/api/mksoft-zakazky/' + encodeURIComponent(cislo) + '/pridat-cislo', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ project_id: projectId, ...telo }) }); return { ok: r.ok, j: await r.json().catch(() => ({})) } }
  const n = await posli({ nahlad: true })
  if (!n.ok) { toast.error(n.j.error || 'Číslo sa nedá pridať.'); return null }
  const s = n.j
  const msg = (s.zlucenie ? `Číslo ${cislo} drží karta ${s.zlucenie.id} „${s.zlucenie.name}“, ktorú Matrix založil z výdajok a nič iné na nej nie je — zlúči sa a pôjde do archívu. ` : '')
    + `Na zákazku ${projectId} prejde: výdajky ${s.vydajky} za ${SK.eur(s.vydajky_suma)} · vystavené FA ${s.fa} za ${SK.eur(s.fa_suma)}${s.fa ? ' (do príjmu ' + s.fa_do_prijmu + ', čaká na potvrdenie ' + s.fa_caka + (s.fa_cisla && s.fa_cisla.length ? ': ' + s.fa_cisla.join(', ') : '') + ')' : ''}. Ďalšie výdajky a FA s týmto číslom pôjdu sem samy.`
  const ano = await opytajSa({ title: (s.zlucenie ? 'Zlúčiť a pridať číslo ' : 'Pridať číslo ') + cislo + '?', message: msg, confirmLabel: s.zlucenie ? 'Zlúčiť a pridať' : 'Pridať číslo' })
  if (!ano) return null
  const v = await posli({ zlucit: !!s.zlucenie })
  if (!v.ok) { toast.error(v.j.error || 'Číslo sa nepridalo.'); return null }
  const j = v.j
  toast.success(`Číslo ${cislo} pridané${j.zlucena ? ', karta ' + j.zlucena.id + ' zlúčená' : ''} — výdajok ${j.vydajky}, FA ${j.fa}${j.fa ? ' (do príjmu ' + j.fa_do_prijmu + ')' : ''}.`)
  return j
}
export function MksoftDalsieCisloOkno({ project, open, onClose, onChanged }) {
  const toast = useToast()
  const opytajSa = useConfirm()
  const [pracuje, setPracuje] = useState(false)
  const pridaj = async (cislo) => {
    if (!cislo || pracuje) return
    setPracuje(true)
    try { const j = await pridajDalsieCislo({ cislo, projectId: project.id, opytajSa, toast }); if (j) { onClose && onClose(); onChanged && onChanged() } }
    catch (e) { toast.error(e.message) } finally { setPracuje(false) }
  }
  return (
    <Modal open={!!open} onClose={() => !pracuje && onClose && onClose()} title={'Ďalšie číslo zákazky v MKsofte — ' + project.id + ' ' + (project.name || '')} width="min(640px, 95vw)"
      subtitle="Iné číslo tej istej stavby v MKsofte (napr. potery k omietkam). Výdajky aj vystavené FA s týmto číslom pôjdu na túto kartu. Jedno číslo patrí jednej karte."
      footer={<><span style={{ flex: 1 }} /><Btn onClick={() => onClose && onClose()} disabled={pracuje}>Zrušiť</Btn></>}>
      {open && <ParovanieMKsoft typ="zakazka" hodnota="" nazov={project.name} partnerId={project.customerId} vlastnyId={project.id} onVyber={pridaj} povolPrazdne lenZoZoznamu />}
    </Modal>
  )
}

export function MksoftStavKarty({ project, onChanged }) {
  const [okno, setOkno] = useState(false)
  const [info, setInfo] = useState(null)
  const kod = String(project.zakazka_code || project.mksoft_cislo || '').trim()
  useEffect(() => { let on = true; fetchAuth('/api/mksoft-zakazky').then(r => r.ok ? r.json() : null).then(j => { if (on) setInfo(j) }).catch(() => {}); return () => { on = false } }, [project.id, kod])
  const mk = info && kod ? info.zoznam.find(z => z.cislo === kod) : null
  const znamy = !info || info.pocet === 0 || !!mk
  const smie = !info || info.smie
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <StitokMKsoft kod={kod} znamy={znamy} />
      {mk && <span style={{ fontWeight: 400 }}>{mk.nazov}{mk.zakaznik ? ' · ' + mk.zakaznik.name : ''}</span>}
      {!kod && <span style={{ fontSize: TYPO.sizes.xs, color: '#b91c1c', fontWeight: 400 }}>bez čísla sa VSZAK a VSOST k zákazke nepriradia</span>}
      {smie && <Btn size="sm" variant={kod ? 'ghost' : 'nav'} onClick={() => setOkno(true)}>{kod ? 'Zmeniť' : 'Spárovať s MKsoftom'}</Btn>}
      <MksoftParovanieOkno project={project} open={okno} onClose={() => setOkno(false)} onChanged={onChanged} />
    </span>
  )
}

// ══ MKSOFT_VAZBY_V1 — párovanie s MKsoftom v nervovej sústave (Mirko 21. 10. 2026: „MK soft parovanie nech je v nervovej sústave …
// partie, rozpis“ · „aby to matrix vedel - nerovoá sustava, postav to ano“, Kronika mksoft 2526/2529) ══════════════════════════════
// Jeden štítok (StitokMKsoft), jeden stav pre ktorýkoľvek tab (useStavVazieb), jeden výber a jedno okno (VazbaMKsoftOkno) pre všetky druhy.
// Druhy: zakazka (okno = MksoftParovanieOkno, 23.3.A) · zamestnanec (osoba podľa RČ, API mksoft_personalistika) · partia · partner · polozka (API /api/mksoft-vazby).
// Z MKsoftu len čítame; väzba sa ukladá len v registri Matrixu. Nič sa nespáruje samo — vyber, pozri súhrn, potvrď.
export const VAZBY_DRUHY = {
  zakazka: { nazov: 'Zákazky', jedna: 'Zákazka', co: 'MKsoft zákazka', hladaj: 'číslo alebo názov MKsoft zákazky…' },
  partia: { nazov: 'Partie', jedna: 'Partia', co: 'odberateľ náradia v MKsofte', hladaj: 'kód alebo názov odberateľa…' },
  zamestnanec: { nazov: 'Zamestnanci', jedna: 'Zamestnanec', co: 'osoba v MKsofte', hladaj: 'meno…' },
  partner: { nazov: 'Partneri', jedna: 'Partner', co: 'firma v adresári MKsoftu', hladaj: 'IČO alebo názov firmy…' },
  polozka: { nazov: 'Položky (PLU)', jedna: 'Položka', co: 'PLU v cenníku MKsoftu', hladaj: 'PLU alebo názov…' },
}

// stav väzieb pre zoznam id — { id: { stav: 'ok'|'nv'|'wa'|'no', kod, navrh } }; bez osobných údajov, pre každého prihláseného
export function useStavVazieb(druh, ids, obnov = 0) {
  const [stav, setStav] = useState({})
  const kluc = (ids || []).filter(Boolean).join(',')
  useEffect(() => {
    if (!kluc) { setStav({}); return }
    let on = true
    const daj = (u) => fetchAuth(u + encodeURIComponent(kluc)).then(r => r.ok ? r.json() : null).catch(() => null)
    if (druh === 'zamestnanec') {
      // MKSOFT_VAZBY_V2: zamestnanec je v MKsofte ako osoba (mzdy) ALEBO cez firmu s IČO (živnosť, rodina, subdodávka) — osoba má prednosť
      Promise.all([daj('/api/mksoft-personalistika/stav?ids='), daj('/api/mksoft-vazby/zamestnanec/ico?ids=')]).then(([o, i]) => {
        if (!on) return
        const so = (o && o.stav) || {}, si = (i && i.stav) || {}, out = {}
        new Set([...Object.keys(so), ...Object.keys(si)]).forEach(k => {
          const a = so[k], b = si[k]
          out[k] = a && a.stav === 'ok' ? a : b && (b.stav === 'ok' || !a || a.stav === 'no') ? { ...b, osoba: a ? a.stav : '' } : a
        })
        setStav(out)
      })
    } else {
      daj('/api/mksoft-vazby/' + druh + '/stav?ids=').then(j => { if (on && j) setStav(j.stav || {}) })
    }
    return () => { on = false }
  }, [druh, kluc, obnov])
  return stav
}

// štítok zo stavu väzby — rovnaké farby všade (✓ zelená, ? modrá, ! žltá, ✗ červená)
export function StitokVazby({ s, title }) {
  if (!s) return null
  if (s.stav === 'ok') return <StitokMKsoft kod={s.kod || s.oc || '✓'} title={title || s.nazov || (s.cez === 'ico' ? 'v MKsofte cez firmu s IČO (živnosť, rodina alebo subdodávka)' : undefined)} />
  if (s.stav === 'wa') return <StitokMKsoft kod={s.kod} znamy={false} title={title} />
  if (s.stav === 'nv') return <StitokMKsoft navrh title={title || (s.cez === 'ico' ? 'firma s IČO má návrh v adresári MKsoftu' : s.navrh ? 'Návrh z MKsoftu: ' + s.navrh + (s.navrh_nazov ? ' ' + s.navrh_nazov : '') : 'Matrix má návrh z MKsoftu')} />
  return <StitokMKsoft kod="" title={title} />
}

// výber páru z MKsoftu pre partiu, partnera alebo položku — kandidáti so skóre a dôvodom, obsadené sivé, súhrn pred potvrdením
export function VazbaMKsoftVyber({ druh, id, onHotovo }) {
  const toast = useToast()
  const D = VAZBY_DRUHY[druh] || {}
  const [data, setData] = useState(null)
  const [nacitava, setNacitava] = useState(false)
  const [q, setQ] = useState('')
  const [kurzor, setKurzor] = useState(0)
  const [vyber, setVyber] = useState(null)
  const [dosledok, setDosledok] = useState(null)
  const [rucne, setRucne] = useState(false)
  const [rucneKod, setRucneKod] = useState('')
  const [pracuje, setPracuje] = useState(false)
  const nacitaj = async (onl) => {
    setNacitava(true)
    try {
      const r = await fetchAuth('/api/mksoft-vazby/' + druh + '/' + encodeURIComponent(id) + '/kandidati' + (onl ? '?online=1' : ''))
      const j = await r.json().catch(() => ({}))
      setData(r.ok ? j : { chyba: j.error || 'Nedá sa načítať.' })
    } catch (_) { setData({ chyba: 'Nedá sa načítať.' }) } finally { setNacitava(false) }
  }
  useEffect(() => { setVyber(null); setDosledok(null); setQ(''); nacitaj(false) }, [druh, id])   // eslint-disable-line
  useEffect(() => {
    if (!vyber) { setDosledok(null); return }
    let on = true
    fetchAuth('/api/mksoft-vazby/' + druh + '/' + encodeURIComponent(id) + '/dosledok?kod=' + encodeURIComponent(vyber.kod)).then(r => r.ok ? r.json() : null).then(j => { if (on) setDosledok(j ? j.body : []) }).catch(() => {})
    return () => { on = false }
  }, [vyber, druh, id])
  const zoznam = useMemo(() => {
    const k = (data && data.kandidati) || []
    return k.filter(x => !q || hladaj(x.kod + ' ' + x.nazov + ' ' + (x.dovod || ''), q))
      .sort((a, b) => (!!a.obsadene - !!b.obsadene) || (b.skore - a.skore) || String(a.nazov).localeCompare(String(b.nazov), 'sk'))
  }, [data, q])
  const volne = zoznam.filter(x => !x.obsadene)
  useEffect(() => { setKurzor(0) }, [q, data])
  const zapis = async (kod, odpojit, rucneZ) => {
    setPracuje(true)
    try {
      const r = await fetchAuth('/api/mksoft-vazby/' + druh + '/' + encodeURIComponent(id) + (odpojit ? '/odpojit' : '/sparovat'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(odpojit ? {} : { kod, rucne: !!rucneZ }) })
      const j = await r.json().catch(() => ({}))
      if (!r.ok) { toast.error(j.error || 'Neuložené.'); return }
      toast.success(odpojit ? 'Odpojené od MKsoftu.' : 'Spárované s MKsoftom ' + kod + (j.faktury_priradene ? ' — priradených faktúr: ' + j.faktury_priradene : ''))
      onHotovo && onHotovo(j)
    } catch (e) { toast.error(e.message) } finally { setPracuje(false) }
  }
  const naKlaves = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setKurzor(k => Math.min(k + 1, volne.length - 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setKurzor(k => Math.max(k - 1, 0)) }
    else if (e.key === 'Enter') { e.preventDefault(); if (vyber) zapis(vyber.kod) ; else if (volne[kurzor]) setVyber(volne[kurzor]) }
    else if (e.key === 'Escape') { e.preventDefault(); if (vyber) setVyber(null); else setQ('') }
  }
  if (data && data.chyba) return <div style={{ color: '#b91c1c', fontSize: TYPO.sizes.sm }}>{data.chyba}</div>
  const karta = data && data.karta
  const smie = !data || data.smie
  const agent = data && data.agent
  const stavTxt = nacitava ? 'Načítavam z MKsoftu…' : agent ? (agent.online ? 'MKsoft online (' + Math.round((agent.cas_ms || 0) / 1000) + ' s)' : agent.chyba || '') : data && data.adresar ? 'adresár MKsoftu: ' + data.adresar.pocet + (data.adresar.nacitane_at ? ', ' + fmtDatum(data.adresar.nacitane_at) : '') : ''
  return (
    <div>
      {karta && (
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
          <b style={{ fontSize: TYPO.sizes.md }}>{karta.nazov}</b>
          <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{karta.popis}</span>
          {karta.kod ? <StitokMKsoft kod={karta.kod} /> : <StitokMKsoft kod="" />}
          {karta.kod && smie && <Btn size="sm" variant="danger" disabled={pracuje} onClick={() => { if (window.confirm('Odpojiť ' + karta.nazov + ' od MKsoftu ' + karta.kod + '?')) zapis('', true) }}>Odpojiť</Btn>}
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
        <input value={q} onChange={e => setQ(e.target.value)} onKeyDown={naKlaves} placeholder={D.hladaj} autoFocus
          style={{ flex: 1, minWidth: 180, padding: '7px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, fontSize: TYPO.sizes.md }} />
        <span style={{ fontSize: TYPO.sizes.xs, color: agent && !agent.online ? '#b45309' : COLORS.muted, fontWeight: 700 }}>{stavTxt}</span>
        {druh === 'partner' && <Btn size="sm" onClick={() => nacitaj(true)} disabled={nacitava}>Načítať z MKsoftu znova</Btn>}
      </div>
      <div style={{ maxHeight: 300, overflow: 'auto' }}>
        {zoznam.slice(0, 60).map((x, i) => {
          const naj = i === 0 && !x.obsadene && x.skore >= 80 && !q
          const on = vyber && vyber.kod === x.kod
          return (
            <div key={x.kod} onClick={() => { if (!x.obsadene) setVyber(x) }} onMouseEnter={() => { if (!x.obsadene) setKurzor(volne.indexOf(x)) }}
              style={{ display: 'flex', alignItems: 'center', gap: 10, border: '1px solid ' + (on ? '#1d4ed8' : x.obsadene ? COLORS.line : volne[kurzor] === x ? '#93c5fd' : naj ? '#86efac' : COLORS.line), background: on ? '#eff6ff' : x.obsadene ? COLORS.bgSoft : naj ? '#f0fdf4' : '#fff', borderRadius: 10, padding: '6px 10px', marginBottom: 4, cursor: x.obsadene ? 'default' : 'pointer', opacity: x.obsadene ? .7 : 1 }}>
              <span style={{ minWidth: 44, textAlign: 'center', fontWeight: 800, fontSize: 12, borderRadius: 6, padding: '2px 0', background: x.obsadene ? '#f1f5f9' : x.skore >= 80 ? '#dcfce7' : x.skore >= 30 ? '#fef3c7' : '#f1f5f9', color: x.obsadene ? COLORS.muted : x.skore >= 80 ? '#15803d' : x.skore >= 30 ? '#b45309' : COLORS.muted }}>{x.obsadene ? '—' : x.skore + ' %'}</span>
              <b style={{ fontFamily: TYPO.mono, minWidth: 62 }}>{x.kod}</b>
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ fontWeight: 600 }}>{x.nazov}</span>
                <small style={{ display: 'block', color: COLORS.muted }}>{x.obsadene ? 'patrí: ' + x.obsadene.nazov : x.dovod}</small>
              </span>
            </div>
          )
        })}
        {data && !zoznam.length && <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, padding: 6 }}>{q ? 'Nič sa nenašlo.' : 'MKsoft nič podobné nenašiel — skús hľadanie alebo napíš kód ručne.'}</div>}
      </div>
      {vyber && (
        <div style={{ border: '1px dashed #1d4ed8', background: '#eff6ff', borderRadius: 8, padding: '8px 12px', margin: '8px 0', fontSize: TYPO.sizes.sm }}>
          <b>Čo sa stane po potvrdení</b>
          <ul style={{ margin: '4px 0 0', paddingLeft: 18 }}>
            <li><b>{karta ? karta.nazov : id}</b> ↔ MKsoft <b>{vyber.kod}</b> {vyber.nazov}</li>
            {(dosledok || []).map((t, i) => <li key={i}>{t}</li>)}
            <li>Zápis do histórie: kto, kedy, z čoho na čo. Do MKsoftu sa nič nezapisuje.</li>
          </ul>
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
        {!rucne ? <>
          {smie && <Btn size="sm" onClick={() => { setRucne(true); setRucneKod('') }}>Napísať ručne</Btn>}
          <span>↑↓ pohyb · Enter vybrať a potvrdiť · Esc späť</span>
          <span style={{ flex: 1 }} />
          {vyber && <Btn size="sm" onClick={() => setVyber(null)} disabled={pracuje}>Zrušiť výber</Btn>}
          {smie && <Btn size="sm" variant="add" disabled={!vyber || pracuje} onClick={() => vyber && zapis(vyber.kod)}>Potvrdiť spárovanie</Btn>}
        </> : <>
          <input value={rucneKod} onChange={e => setRucneKod(e.target.value.trim().slice(0, 20))} placeholder="kód v MKsofte" autoFocus
            onKeyDown={e => { if (e.key === 'Enter' && rucneKod) { zapis(rucneKod, false, true); setRucne(false) } if (e.key === 'Escape') setRucne(false) }}
            style={{ width: 140, padding: '5px 8px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, fontFamily: TYPO.mono }} />
          <Btn size="sm" variant="add" disabled={!rucneKod || pracuje} onClick={() => { zapis(rucneKod, false, true); setRucne(false) }}>Použiť</Btn>
          <Btn size="sm" onClick={() => setRucne(false)}>Späť</Btn>
          <span>ručný kód dostane žltý štítok, kým ho MKsoft nepotvrdí</span>
        </>}
      </div>
    </div>
  )
}

// jedno okno „Spárovať s MKsoftom“ pre každý druh — zákazka a zamestnanec idú do svojho modulu, ostatné cez VazbaMKsoftVyber
export function VazbaMKsoftOkno({ druh, id, nazov, open, onClose, onChanged, project }) {
  const D = VAZBY_DRUHY[druh] || {}
  if (!open) return null
  if (druh === 'zakazka') return <MksoftParovanieOkno project={project || { id, name: nazov }} open={open} onClose={onClose} onChanged={onChanged} />
  return (
    <Modal open={!!open} onClose={onClose} title={'Spárovať s MKsoftom — ' + (D.jedna || '') + ' ' + (nazov || id)} width="min(720px, 95vw)"
      subtitle={'Matrix ponúkne ' + (D.co || 'pár z MKsoftu') + ' — vyber, pozri súhrn a potvrď. Nič sa nespáruje samo.'}
      footer={<><span style={{ flex: 1 }} /><Btn onClick={onClose}>Zavrieť</Btn></>}>
      <VazbaMKsoftVyber druh={druh} id={id} onHotovo={(j) => { onChanged && onChanged(j); onClose && onClose() }} />
    </Modal>
  )
}

// štítok + tlačidlo na karte (Partie, Partneri, …): stav väzby a Spárovať / Zmeniť
export function StavVazby({ druh, id, nazov, onChanged, smie = true }) {
  const [okno, setOkno] = useState(false)
  const [obnov, setObnov] = useState(0)
  const st = useStavVazieb(druh, [id], obnov)[id]
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <StitokVazby s={st || { stav: 'no' }} />
      {st && st.nazov && <span style={{ fontWeight: 400 }}>{st.nazov}</span>}
      {st && st.stav === 'nv' && st.navrh && <span style={{ fontSize: TYPO.sizes.xs, color: '#1d4ed8' }}>návrh: {st.navrh}{st.navrh_nazov ? ' · ' + st.navrh_nazov : ''}</span>}
      {smie && <Btn size="sm" variant={st && st.stav === 'ok' ? 'ghost' : 'nav'} onClick={() => setOkno(true)}>{st && st.stav === 'ok' ? 'Zmeniť' : 'Spárovať s MKsoftom'}</Btn>}
      <VazbaMKsoftOkno druh={druh} id={id} nazov={nazov} open={okno} onClose={() => setOkno(false)} onChanged={() => { setObnov(x => x + 1); onChanged && onChanged() }} />
    </span>
  )
}
